import React, { Fragment, useEffect, useState } from "react";
import { filterSearch } from "../../Utils/FilterItems";
import DataTableCommon from "../../Component/Templates/DataTable/DataTableCommon";
import FilterComponent from "../../Component/FilterComponents/FilterComponent";

const PengaturanListLayout = ({
  items,
  pending,
  searchCategories,
  itemColumns,
}) => {
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    setFilteredItems(
      searchCategories
        ? items?.filter(filterSearch(searchCategories, filterText))
        : items
    );
  }, [items, filterText]);

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const getSubHeaderComponent = () => {
    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={() => handleClear()}
        filterText={filterText}
      />
    );
  };

  return (
    <Fragment>
      <DataTableCommon
        columns={itemColumns}
        data={filteredItems}
        paginationResetDefaultPage={resetPaginationToggle}
        subHeaderComponent={getSubHeaderComponent()}
        progressPending={pending}
      />
    </Fragment>
  );
};

export default PengaturanListLayout;
